/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountMiniSchema
 */
export interface AccountMiniSchema {
    /**
     * 
     * @type {string}
     * @memberof AccountMiniSchema
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof AccountMiniSchema
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof AccountMiniSchema
     */
    id: number;
}

/**
 * Check if a given object implements the AccountMiniSchema interface.
 */
export function instanceOfAccountMiniSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "slug" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function AccountMiniSchemaFromJSON(json: any): AccountMiniSchema {
    return AccountMiniSchemaFromJSONTyped(json, false);
}

export function AccountMiniSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountMiniSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'slug': json['slug'],
        'name': json['name'],
        'id': json['id'],
    };
}

export function AccountMiniSchemaToJSON(value?: AccountMiniSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'slug': value.slug,
        'name': value.name,
        'id': value.id,
    };
}

